import { usePromisedRequest as promiseRequest } from "../../Common/request";
import { resolveNoContent, resolveWithBody } from "../Utils/utils";

export type PreviewTemplatesRequest = {
    templateNames: string[];
};

export type DetailedPreviewRequest = {
    templateNames: string[];
    selectedAgeClasses?: string[];
    selectedGenders?: string[];
    selectedExperienceLevels?: string[];
};

export type TemplateDescription = {
    id: string;
    name: string;
};

export type DetailedCategoryPreview = {
    path: string;
    formattedName: string;
    ageMin: number | null;
    ageMax: number | null;
    gender: string | null;
    fightTime: number | null;
};

export type AvailableFilters = {
    ageClasses: string[];
    genders: string[];
    experienceLevels: string[];
};

export type DetailedPreviewResponse = {
    categories: DetailedCategoryPreview[];
    availableFilters: AvailableFilters;
};

export type SelectedCategoriesImportRequest = {
    templateNames: string[];
    categoryPaths: string[];
    branchName?: string;
};

export default {
    importSelected(eventId: number, request: SelectedCategoriesImportRequest): Promise<void> {
        return promiseRequest({
            url: `/api/admin/events/${eventId}/categories-templates/actions/import-selected`,
            json: request,
            method: "post",
        }).then(resolveNoContent());
    },
    /**
     * Event-less variants for use before an event exists yet (e.g. the tournament creation
     * wizard's Step 5), also reused by the standalone Categories Manager's read-only preview
     * flows since they never depended on the event either. Gated only by organizer role.
     */
    getAvailableTemplatesForOrganizer(): Promise<TemplateDescription[]> {
        return promiseRequest<TemplateDescription[]>({
            url: `/api/admin/categories-templates`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    previewTemplatesForOrganizer(request: PreviewTemplatesRequest): Promise<string[]> {
        return promiseRequest<string[]>({
            url: `/api/admin/categories-templates/actions/preview-templates`,
            method: "post",
            json: request,
        }).then(resolveWithBody());
    },
    getDetailedPreviewForOrganizer(request: DetailedPreviewRequest): Promise<DetailedPreviewResponse> {
        return promiseRequest<DetailedPreviewResponse>({
            url: `/api/admin/categories-templates/actions/detailed-preview`,
            method: "post",
            json: request,
        }).then(resolveWithBody());
    },
};
